<form class="mc-spring-board" [formGroup]="formGroup" (ngSubmit)="onSubmit()">
  <div class="mc-spring-board-header" *ngIf="formHeader">
    <ng-container [ngTemplateOutlet]="formHeader.templateRef"></ng-container>
  </div>

  <div class="mc-spring-board-form-body">
    <ng-container *ngIf="formBody" [ngTemplateOutlet]="formBody.templateRef"></ng-container>
  </div>

  <div class="mc-spring-board-form-footer">
    <ng-container *ngIf="formFooter" [ngTemplateOutlet]="formFooter.templateRef" [ngTemplateOutletContext]="{ savingState: savingState }">
    </ng-container>

    <ng-container *ngIf="!formFooter">
      <mc-errors-expansion-panel *ngIf="savingState.generalError$ | async as generalError" compact [generalError]="generalError" [detailedErrors]="savingState.detailedErrors$ | async"></mc-errors-expansion-panel>
      <div class="mc-form-buttons">
        <button type="button" *ngIf="deleteFn" color="warn" mat-raised-button (click)="onDelete()">Delete</button>
        <span class="mc-fill-remaining-flex-space"></span>
        <button type="button" mat-stroked-button (click)="cancel.emit()">Cancel</button>
        <button type="submit" mat-raised-button color="primary" [disabled]="!formGroup.valid || formGroup.pristine">Save</button>
      </div>
    </ng-container>
  </div>

  <mc-loader *ngIf="savingState.loading$ | async" class="mc-loader-semi-transparent"></mc-loader>
  <mc-loader *ngIf="loadingState?.loading$ | async"></mc-loader>
  <mc-errors-expansion-panel *ngIf="loadingState?.generalError$ | async as generalError" compact [generalError]="generalError" [detailedErrors]="loadingState.detailedErrors$ | async"></mc-errors-expansion-panel>

</form>